export const BIORHYTHM_SCORE_MASTER = [50, 70, 80, 90]
export const BIORHYTHM_METHOD_MASTER = ['ポイント', '棒グラフ', '直線', '曲線']



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/Products/kurenotori/constants.js